<app-expandable-section-box
  [title]="'Advertorial Client'"
  [iconClass]="'icon-folder'"
  [isExpandedByDefault]="isExpandedByDefault"
  [isExpandable]="isExpandable"
>
  <div class="flex flex-col gap-y-[0.3rem] py-0 px-2 flex-1" expandedContent>
    <div class="p-2">
      <mat-form-field class="w-full text-project-50" [appearance]="'outline'">
        <input
          type="text"
          matInput
          name="Client"
          [formControl]="sponsoredClientControl"
          placeholder="Client"
          class="text-project-1400"
        />
      </mat-form-field>
      <mat-form-field class="w-full text-project-50" [appearance]="'outline'">
        <input
          type="text"
          matInput
          name="Sales Order"
          [formControl]="salesOrderControl"
          placeholder="Sales Order"
          class="text-project-1400"
        />
      </mat-form-field>
    </div>
  </div>
  <div
    class="flex flex-col w-full py-2 m-0 space-y-4 text-xs empty:py-0 bg-project-2200"
    *ngIf="sponsoredClientControl.value || salesOrderControl.value"
    notExpandedContent
  >
    <ng-container>
      <div *ngIf="sponsoredClientControl.value">
        <b>Client</b>
        <p class="text-project-2400">
          {{ sponsoredClientControl.value }}
        </p>
      </div>
      <div *ngIf="salesOrderControl.value">
        <b>Sales Order</b>
        <p class="text-project-2400">
          {{ salesOrderControl.value }}
        </p>
      </div>
    </ng-container>
  </div>
</app-expandable-section-box>
